import { render, staticRenderFns } from "./Cn-TestMethod.vue?vue&type=template&id=2f4739c5&scoped=true&"
import script from "./Cn-TestMethod.vue?vue&type=script&lang=js&"
export * from "./Cn-TestMethod.vue?vue&type=script&lang=js&"
import style0 from "./Cn-TestMethod.vue?vue&type=style&index=0&id=2f4739c5&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f4739c5",
  null
  
)

export default component.exports